import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import SideNavbar from "./SideNavbar";
import Header from "./Header";
import { Cache } from "aws-amplify";

import Dashboard from "../dashboard/Dashboard";
import Projects from "../projects/Projects";
import ViewProject from "../projects/ViewProject";
import ManageTasks from "../projects/ManageTasks";
import ViewProjectTask from "../projects/ViewProjectTask";
import ProjectWizard from "../projects/ProjectWizard";
import ForApproval from "../projects/ForApproval";

import TeamDailyTasks from "../dailyTasks/TeamDailyTask";
import DailyTasks from "../dailyTasks/DailyTasks";
import DailyTasksById from "../dailyTasks/DailyTaskById";
import DailyTaskDetailsById from "../dailyTasks/DailyTaskDetailsById";

import Timesheet from "../timesheet/Timesheet";
import AddTimesheet from "../timesheet/AddTimesheet";

import Approvals from "../approvals/Approvals";

import WeeklyMonthlyReports from "../reports/WeeklyMonthlyReports";
import ProjectRunRate from "../reports/ProjectRunRate";
import MissingEntries from "../reports/MissingEntries";
import ProjectTimesheetCumulative from "../reports/ProjectTimesheetCumulative";
import ProfitabilityPerProject from "../reports/profitabilityPerProject/ProfitabilityPerProject";
import ProfitibilityPerClient from "../reports/profitabilityPerClient/ProfitibilityPerClient";
import Users from "../settings/users/Users";
import UserForm from "../settings/users/UserForm";
import ChangePasswordForm from "../settings/users/ChangePasswordForm";
import Platforms from "../settings/platforms/Platforms";
import PlatformForm from "../settings/platforms/PlatformForm";
import Clients from "../settings/clients/Clients";
import ClientForm from "../settings/clients/ClientForm";
import Holidays from "../settings/holidays/Holidays";
import HolidayForm from "../settings/holidays/HolidayForm";
import Activities from "../settings/activities/Activities";
import CostCenters from "../settings/cost_centers/CostCenters";
import CostCenterForm from "../settings/cost_centers/CostCenterForm";

import {
  getCurrentUser,
  setDefaultRole,
} from "../../store/actions/users/usersActions";
import { getWeeksInYear } from "../../store/actions/commonActions";
import ActivityForm from "../settings/activities/ActivityForm";
import ProductivityReport from "../reports/ProductivityReport";
import AccomplishmentReport from "../reports/AccomplishmentReport";

class Main extends Component {
  componentDidMount() {
    const apiToken = Cache.getItem("apiToken");
    const clickedURL = "clickedURL";
    if (!apiToken) {
      Cache.setItem(
        clickedURL,
        this.props.location.pathname + this.props.location.search
      );
      this.props.history.push("/");
    } else if (Cache.getItem(clickedURL)) {
      this.props.history.push(Cache.getItem(clickedURL));
      Cache.removeItem(clickedURL);
    } else {
      const urlParams = new URLSearchParams(this.props.location.search);
      const paramRoleId = urlParams.get("role_id");

      this.props.getCurrentUser(null, null, paramRoleId);
    }

    this.props.getWeeksInYear();
  }

  switchContent = () => {
    const pathname = this.props.location.pathname;

    switch (pathname) {
      case "/dashboard":
        return <Dashboard />;
      case "/projects":
      case "/projects/disabled":
        return <Projects />;
      case "/projects/update":
      case "/projects/add":
        return <ProjectWizard />;
      case "/projects/view":
        return <ViewProject />;
      case "/projects/tasks":
        return <ManageTasks />;
      case "/projects/tasks/view":
        return <ViewProjectTask />;
      case "/projects/for-approval":
        return <ForApproval />;
      case "/dailytasks":
      case "/dailytasks/list":
        return <DailyTasks />;
      case "/dailytasks/add":
      case "/dailytasks/view":
        return <DailyTasksById />;
      case "/dailytasks/details":
        return <DailyTaskDetailsById />;
      case "/teamdailytasks":
        return <TeamDailyTasks />;
      case "/timesheet":
        return <Timesheet />;
      case "/timesheet/approval":
      case "/timesheet/update":
      case "/timesheet/add":
        return <AddTimesheet />;
      case "/settings/users":
      case "/settings/users/disabled":
        return <Users />;
      case "/settings/users/update":
      case "/settings/users/add":
        return <UserForm />;
      case "/users/change-password":
        return <ChangePasswordForm />;
      case "/settings/platforms":
        return <Platforms />;
      case "/settings/platforms/view":
        return <PlatformForm viewOnly={true} />;
      case "/settings/platforms/add":
      case "/settings/platforms/update":
        return <PlatformForm />;
      case "/settings/clients":
        return <Clients />;
      case "/settings/clients/add":
      case "/settings/clients/update":
        return <ClientForm />;
      case "/settings/holidays":
        return <Holidays />;
      case "/settings/holidays/add":
      case "/settings/holidays/update":
        return <HolidayForm />;
      case "/settings/tasks":
      case "/settings/tasks/disabled":
        return <Activities />;
      case "/settings/tasks/add":
      case "/settings/tasks/update":
        return <ActivityForm />;
      case "/settings/costcenters":
        return <CostCenters />;
      case "/settings/costcenters/add":
      case "/settings/costcenters/update":
        return <CostCenterForm />;
      case "/approvals":
        return <Approvals />;
      case "/reports/weekly-monthly-reports":
        return <WeeklyMonthlyReports />;
      case "/reports/project-run-rate":
        return <ProjectRunRate />;
      case "/reports/missing-entries":
        return <MissingEntries />;
      case "/reports/project-timesheet-cumulative":
        return <ProjectTimesheetCumulative />;
      case "/reports/profitability-per-project":
        return <ProfitabilityPerProject />;
      case "/reports/profitability-per-client":
        return <ProfitibilityPerClient />;
      case "/reports/productivity-report":
        return <ProductivityReport />;
      case "/reports/accomplishment-report":
        return <AccomplishmentReport />;
      default:
        return <Dashboard />;
    }
  };

  render() {
    return (
      <Container fluid id="t3-main-container">
        <Row>
          <Col sm={12} md={3} lg={2} id="t3-main-side-nav-left">
            <SideNavbar />
          </Col>
          <Col xs={10} sm={10} md={10} lg={10} xl={10} id="t3-main-content">
            <Header />
            <Row className="align-left">
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                {this.switchContent()}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getCurrentUser: (...args) => dispatch(getCurrentUser(...args)),
    getWeeksInYear: () => dispatch(getWeeksInYear()),
    setDefaultRole: (...args) => dispatch(setDefaultRole(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
